import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ActionCreateQuoteSaleRootParamList,
  ActionsRootParamList,
} from "../../../../types";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { CustomerRootScreen } from "../CustomerRootScreen";
import { ConfirmQuoteDetailsScreen } from "../ConfirmQuoteDetailsScreen";
import {
  CustomerRootScreenActionsContext,
  OnAfterCreateCustomerFn,
  OnCustomerSelectedFn,
} from "../CustomerRootScreen/context";
import React from "react";

export interface ActionCreateQuoteSaleRootScreenProps
  extends StackScreenProps<
    ActionsRootParamList & ActionCreateQuoteSaleRootParamList,
    "ActionCreateQuoteSaleRootScreen"
  > {}

export const ActionCreateQuoteSaleRootScreen = ({
  navigation,
}: ActionCreateQuoteSaleRootScreenProps) => {
  const Stack =
    createStackHeaderNavigator<ActionCreateQuoteSaleRootParamList>();

  const handleOnCustomerSelectedOrCreated: OnCustomerSelectedFn =
    React.useCallback(async (customerId) => {
      navigation.navigate("ConfirmQuoteDetailsScreen", {
        customerId,
      });
    }, []);

  return (
    <CustomerRootScreenActionsContext.Provider
      value={{
        onCustomerSelected: handleOnCustomerSelectedOrCreated,
        onAfterCreateCustomer: handleOnCustomerSelectedOrCreated,
      }}
    >
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
        }}
      >
        <Stack.Group
          screenOptions={{
            headerLeft: () => (
              <ModalCloseButton
                onPress={() => navigation.goBack()}
                type="Cancel"
              />
            ),
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Stack.Screen
            options={{
              headerShown: false,
            }}
            name="CustomerRootScreen"
            component={CustomerRootScreen}
          />
          <Stack.Screen
            options={{
              headerShown: true,
            }}
            name="ConfirmQuoteDetailsScreen"
            component={ConfirmQuoteDetailsScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </CustomerRootScreenActionsContext.Provider>
  );
};
